export default __webpack_public_path__ + "static/media/Comp 2_00011.e4f976b1.png";